import apiClient from "../libs/axios";
import { useRouter } from 'vue-router';
import ROUTES from "../constansRoute.js";
import { apiUrl } from "../constans";


const setupInterceptors = (store) => {
    apiClient.interceptors.request.use(
        (config) => {
            const accessToken = store.getters['appAuth/getAccessToken'];

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            return config;
        },


        (error) => {
            return Promise.reject(error);
        }
    );

    apiClient.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            const excludedUrls = [`${apiUrl}/login`, `${apiUrl}/v2/domus/properties`];
            if (!excludedUrls.includes(originalConfig.url)) {
                console.log(originalConfig.url)

                // Access Token was expired
                if (err.response && err.response.status === 401) {
                    const router = useRouter();
                    originalConfig._retry = true;


                    try {
                        const rs = await apiClient.post("/refreshToken");
                        console.log(rs)
                        const { access_token } = rs.data;
                        let response = store.dispatch('appAuth/logout')
                        if (response) {
                            router.push({ name: ROUTES.SIGNIN });
                        }
                        store.dispatch('auth/refreshToken', access_token);

                        return apiClient(originalConfig);
                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setupInterceptors;
